export class WorkspaceNotFoundError extends Error {
    constructor() {
        super('Workspace not found');
        this.name = 'WorkspaceNotFoundError';
    }
}

export class WorkspacePermissionError extends Error {
    constructor() {
        super('Permission denied');
        this.name = 'WorkspacePermissionError';
    }
}

export class WorkspaceLoadError extends Error {
    constructor(cause?: unknown) {
        super('Failed to load workspace');
        this.name = 'WorkspaceLoadError';
        if (cause instanceof Error) {
            this.cause = cause;
        }
    }
}

/**
 * Thrown by {@link WorkspaceService.save} when a save is already in flight.
 *
 * Save is gated (not queued or cancelled) because the create path (first save
 * or `saveAs`) POSTs a new resource; two concurrent POSTs would create two
 * workspaces. Callers should either:
 *   - observe `saveState` and disable their trigger while saving, or
 *   - catch this error and surface it as a user-facing "already saving" hint.
 */
export class WorkspaceSaveInProgressError extends Error {
    constructor() {
        super('Workspace save is already in progress');
        this.name = 'WorkspaceSaveInProgressError';
    }
}
